<template>
  <div class="mb-8 lg:mb-32" v-if="room.name && room.number">
    <div class="text-16 text-blue-900 font-bold">
      {{ __('room_title', { number: room.number }) }}
    </div>

    <h3 class="text-20 text-blue-900 font-bold -mt-10 mb-0">
      {{ room.name }}
    </h3>

    <div v-if="roomFormattedDatetime" class="text-8 font-bold text-blue-900">
      {{ roomFormattedDatetime }}
    </div>
  </div>
</template>

<script>
import { selectedRoom } from '@/stores/Rooms';
import { computed } from 'vue';
import { order } from '@/stores/Order'

export default {
  setup() {
    const room = computed(() => {
      if (selectedRoom.value) {
        return {
          name: selectedRoom.value.name,
          number: selectedRoom.value.number
        };
      }

      return {
        name: null,
        number: null
      };
    });

    const roomFormattedDatetime = computed(() => {
      const startingAt = order.value.starting_at;
      const endingAt = order.value.ending_at;
      if (!startingAt || !endingAt) return '';

      const formatStartDate = (dateString) => {
        const date = new Date(dateString);
        const month = String(date.getMonth() + 1);
        const day = String(date.getDate());
        const hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${day.padStart(2, '0')}.${month.padStart(2, '0')} ${hours}:${minutes}`;
      };

      const formatEndTime = (dateString) => {
        const date = new Date(dateString);
        const hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
      };

      const startingFormatted = formatStartDate(startingAt);
      const endingFormatted = formatEndTime(endingAt);

      return `${startingFormatted} - ${endingFormatted}`;
    });


    return {
      room,
      roomFormattedDatetime
    };
  }
};
</script>
